import { useEffect, useContext, useState } from "react";
import Moment from "moment";
import { post, remove } from "../../../../adapters/xhr/api";
import Modal from "react-modal";
import stylesModal from "./Modal.module.css";

import stylesRequestData from "../../UnifiedTaxDeclarationRequestData/index.module.css";
import SearchSelectElement from "../../../../shared/form/SearchSelectElement";
import InputElement from "../../../../shared/form/InputElement";
import UnifiedTaxDeclarationContext from "../../../../contexts/UnifiedTaxDeclarationProvider";
import FieldRenderer from "../common/FieldRendrer";
import { validateRequired } from "../../../../helpers/Validation";
import { DatePickerFormatedWithLimit } from "../../../../shared/form/DatePickerFormated";
import {
  getStarRatings,
  getViewTypes,
} from "../../../../adapters/apis/lookups/lookups";
import { useLocation, useParams } from "react-router-dom";
import CommonAddressMap from "../../../../shared/pages/map/CommonAddressMap";
import infoIconSvg from "../../../../assets/img/Icon-metro-info.svg";
import InfoPopover from "../../../../shared/form/InfoPopover";
import {
  validateManualCommonAddress,
  validateManualBuildingMatch,
  validateBuildingFilterSearchType,
  hasFilterSearchTypeMismatch,
  getMatchingBuildings,
  getMatchingHotelUnits,
} from "../../helpers/commonValidation";
import { getManualCommonBuilding } from "../../helpers/constants";

const HotelFacilitiesForm = ({
  generateOptions,
  error_new_user,
  setValidFields,
  handleChangeDeclerationUnit,
  setUploadFileError,
  setError,
  fileInputKeys,
  DownloadFile,
  handlePreviewFile,
  constructionPermitsFileInputRef,
  operatingLicensesFileInputRef,
  stardomCertificateFileInputRef,
  doYouWantExtraAttachments,
  setBackendError,
  setSubmissionError,
  setTempFiles,
  unitBuildingMapError,
  setUnitBuildingMapError,
}) => {
  Modal.setAppElement("body");
  const location = useLocation();
  const { id } = useParams();

  const unifiedTaxDeclarationContext = useContext(UnifiedTaxDeclarationContext);
  const {
    declarationRequest,
    updateDeclarationUnit,
    realFloorOther,
    setDeclarationRequest,
    building,
    setBuilding,
    isBuildingEditMode,
    setIsBuildingEditMode,
    isDuplicateRenin,
    setIsDuplicateRenin,
    errorBuilding,
    setErrorBuilding,
    dataMismatchReasonLookup,
    DoYouWantExtraAttachmentsForRequestTypes,
    getLabelById,
    buildingFullAddressDisplay,
    staticGovs,
  } = unifiedTaxDeclarationContext;

  const [viewTypes, setViewTypes] = useState([]);
  const [starRatings, setStarRatings] = useState([]);
  const [licenseDate, setLicenseDate] = useState(null);
  const [buildingsBeforeEdit, setBuildingsBeforeEdit] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [currentHotelUnit, setCurrentHotelUnit] = useState({
    id: null,
    building_id: "",
    building_number: "",
    floor_number_id: "",
    unit_number: "",
    activity_type: "",
    area: "",
    inside_operation_license: "",
    reta_contact_about_unit: "",
    account_code: "",
    market_price: "",
    annual_rent: "",
  });

  const [hotelUnitErrors, setHotelUnitErrors] = useState({
    building_number: "",
    floor_number_id: "",
    floor_number_other: "",
    unit_number: "",
    activity_type: "",
    area: "",
    inside_operation_license: "",
    reta_contact_about_unit: "",
    account_code: "",
    market_price: "",
    annual_rent: "",
  });

  const [addHotelUnitErrorMessage, setAddHotelUnitErrorMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [hotelUnitToDelete, setHotelUnitToDelete] = useState(null);
  const [hotelUnitIndexToDelete, setHotelUnitIndexToDelete] = useState(null);
  const [editingHotelUnitIndex, setEditingHotelUnitIndex] = useState(null);

  // Building section state
  const [staticBuilding, setStaticBuilding] = useState(null);
  const [isAddBuildingButtonDisabled, setIsAddBuildingButtonDisabled] =
    useState(false);
  const [addBuildingErrorMessage, setAddBuildingErrorMessage] = useState("");
  const [showBuildingModal, setShowBuildingModal] = useState(false);
  const [idBuildingToBeDeleted, setIdBuildingToBeDeleted] = useState(null);
  const [staticHotelUnit, setStaticHotelUnit] = useState(null);
  const [fileErrors, setFileErrors] = useState({});
  const [showDeleteOther, setShowDeleteOther] = useState(false);

  const canEditUnit =
    !declarationRequest?.viewMode && !declarationRequest?.isUnitViewMode;

  useEffect(() => {
    setIsDuplicateRenin("");
    setUnitBuildingMapError("");
    setBuilding(null);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const loadLookups = async () => {
      try {
        const [viewRes, starRes] = await Promise.all([
          getViewTypes(),
          getStarRatings(),
        ]);
        setViewTypes(viewRes?.data?.data || []);
        setStarRatings(starRes?.data?.data || []);
      } catch (error) {
        console.error("Error loading hotel lookups:", error);
      }
    };

    loadLookups();
  }, []);

  useEffect(() => {
    if (declarationRequest?.unit?.license_date) {
      setLicenseDate(new Date(declarationRequest?.unit?.license_date));
    }
  }, [declarationRequest?.unit?.license_date]);

  useEffect(() => {
    setIsDuplicateRenin("");
    setUnitBuildingMapError("");
  }, [declarationRequest?.filter_search_type_id]);

  useEffect(() => {
    if (!parseInt(declarationRequest?.unit?.buildings_count)) {
      setIsAddBuildingButtonDisabled(true);
    } else if (
      getMatchingBuildings(declarationRequest)?.length >=
      parseInt(declarationRequest?.unit?.buildings_count || 1)
    ) {
      setIsAddBuildingButtonDisabled(true);
    } else {
      setIsAddBuildingButtonDisabled(false);
    }
  }, [
    declarationRequest?.unit?.buildings_count,
    declarationRequest?.unit?.buildings,
    getMatchingBuildings(declarationRequest),
  ]);

  useEffect(() => {
    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...prev.unit,
        buildings_count: declarationRequest?.unit?.buildings_count || 1,
      },
    }));
  }, []);

  useEffect(() => {
    if (
      parseInt(declarationRequest?.unit?.buildings_count || 1) <
      getMatchingBuildings(declarationRequest)?.length
    ) {
      setAddBuildingErrorMessage(
        "يجب أن يكون عدد المباني أكبر من إجمالي المباني المُدخلة أو مساويًا لها",
      );
    } else if (
      parseInt(declarationRequest?.unit?.buildings_count || 1) ===
      getMatchingBuildings(declarationRequest)?.length
    ) {
      setAddBuildingErrorMessage("");
      setIsAddBuildingButtonDisabled(true);
    } else {
      setAddBuildingErrorMessage("");
      setIsAddBuildingButtonDisabled(false);
    }
  }, [
    declarationRequest?.unit?.buildings_count,
    declarationRequest?.unit?.buildings?.length,
    getMatchingBuildings(declarationRequest),
  ]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!declarationRequest?.unit?.building?.buildingProfile) {
      setAddBuildingErrorMessage("");
      setIsAddBuildingButtonDisabled(true);
    } else {
      setAddBuildingErrorMessage("");
      setIsAddBuildingButtonDisabled(false);
    }
  }, [declarationRequest?.unit?.building?.buildingProfile]);

  // ── Building helpers ──────────────────────────────────────────────────────

  const setEachErrorBuilding = (key, value) => {
    setErrorBuilding((prev) => ({ ...prev, [key]: value }));
  };

  const handleUpdateBuilding = (pc, c, field, value) => {
    setBuilding({ ...building, [field]: value });
  };

  const canAppendBuilding = (
    newBuildingProfile,
    declarationUnit,
    existingBuildings = [],
  ) => {
    if (!newBuildingProfile?.renin) return false; // must have renin

    if (parseInt(declarationUnit?.building?.mismatch_reason_id) === 3) {
      return true;
    } else {
      return !existingBuildings
        .filter((b) => parseInt(b?.mismatch_reason_id) !== 3)
        .some((b) => b?.buildingProfile?.renin == newBuildingProfile.renin);
    }
  };

  const validateBeforeSubmitBuilding = () => {
    let isFormValid = true;
    let isManualValid = true;

    if (!validateRequired(building?.rooms_number)) {
      setEachErrorBuilding("rooms_number", "يجب إدخال عدد الغرف");
      isFormValid = false;
    } else {
      setEachErrorBuilding("rooms_number", "");
    }

    // if (
    //   !validateRequired(building?.buildingProfile?.number) ||
    //   building?.buildingProfile?.number === 0
    // ) {
    //   if (!validateRequired(building?.known_build_num)) {
    //     setEachErrorBuilding(
    //       "known_build_num",
    //       "يجب إدخال رقم العقار/المبنى المتعارف عليه",
    //     );
    //     isFormValid = false;
    //   } else {
    //     setEachErrorBuilding("known_build_num", "");
    //   }
    // }

    if (building?.main_building !== 1) {
      if (parseInt(declarationRequest?.unit?.filter_search_type_id) !== 3) {
        if (
          !validateRequired(
            declarationRequest?.unit?.building?.is_map_address_matching,
          )
        ) {
          setEachErrorBuilding("is_map_address_matching", "يجب اختيار إجابة");
          isFormValid = false;
        } else {
          // Rule 2: if no known_build_num AND is_map_address_matching === 1 → special error
          if (
            !validateRequired(
              declarationRequest?.unit?.building?.buildingProfile?.number,
            ) &&
            parseInt(
              declarationRequest?.unit?.building?.is_map_address_matching,
            ) === 1
          ) {
            setEachErrorBuilding(
              "is_map_address_matching",
              "لا يمكن الإستمرار بالإجابة “نعم” لعدم توفر رقم العقار، برجاء تصحيح البيانات و إدخال رقم العقار/المبنى المتعارف عليه",
            );
            isFormValid = false;
          } else {
            setEachErrorBuilding("is_map_address_matching", "");
          }
        }

        if (
          parseInt(
            declarationRequest?.unit?.building?.is_map_address_matching,
          ) === 2
        ) {
          if (
            !validateRequired(
              declarationRequest?.unit?.building?.mismatch_reason_id,
            )
          ) {
            setEachErrorBuilding("mismatch_reason_id", "يجب اختيار إجابة");
            isFormValid = false;
          } else {
            setEachErrorBuilding("mismatch_reason_id", "");
          }
        }

        if (
          !validateRequired(
            declarationRequest?.unit?.building?.buildingProfile?.number,
          )
        ) {
          if (
            !validateRequired(
              declarationRequest?.unit?.building?.known_build_num,
            )
          ) {
            setEachErrorBuilding(
              "known_build_num",
              "يجب إدخال رقم العقار/المبنى المتعارف عليه",
            );
            isFormValid = false;
          } else {
            setEachErrorBuilding("known_build_num", "");
          }
        } else {
          setEachErrorBuilding("known_build_num", "");
        }

        if (
          parseInt(
            declarationRequest?.unit?.building?.is_map_address_matching,
          ) === 2
        ) {
          if (
            !validateRequired(
              declarationRequest?.unit?.building?.mismatch_reason_id,
            )
          ) {
            setEachErrorBuilding("mismatch_reason_id", "يجب إختيار إجابه");
            isFormValid = false;
          } else {
            setEachErrorBuilding("mismatch_reason_id", "");
          }
        }
      } else {
        isManualValid = validateManualCommonAddress(
          declarationRequest,
          validateRequired,
          setError,
          setValidFields,
          false,
        );
      }
    } else {
      if (parseInt(declarationRequest?.unit?.filter_search_type_id) === 3) {
        isManualValid = validateManualCommonAddress(
          declarationRequest,
          validateRequired,
          setError,
          setValidFields,
          true,
        );
      } else {
        isManualValid = true;
      }
    }

    return isFormValid && isManualValid;
  };

  const ensureBuildingId = (b) => {
    return {
      ...b,
      id: b?.id ?? crypto.randomUUID(), // always guarantee an id
    };
  };

  const validateBuildingProfileMatch = (unitProfile, buildingProfile) => {
    if (!unitProfile || !buildingProfile) return false;

    const unitIds = unitProfile.address_ids ?? {};
    const buildingIds = buildingProfile.address_ids ?? {};

    const keysToCheck = [
      "district_id",
      "goveronrate_id",
      "city_id",
      "policestation_id",
    ];

    // return true only if all 4 values are equal
    return keysToCheck.every((key) => unitIds[key] === buildingIds[key]);
  };

  const handleAddBuilding = async (shouldShowModal) => {
    setIsSubmitting(true);
    setEachErrorBuilding("known_build_num", "");
    let url;
    let isValid = false;

    const isBuildingHasDifferentSearchType = validateBuildingFilterSearchType(
      declarationRequest,
      declarationRequest?.unit?.filter_search_type_id,
    );

    const isMatching = validateBuildingProfileMatch(
      declarationRequest?.unit?.buildingProfile,
      declarationRequest?.unit?.building?.buildingProfile,
    );

    if (parseInt(declarationRequest?.unit?.filter_search_type_id) !== 3) {
      if (!isMatching) {
        setIsDuplicateRenin(
          "لا يمكن إضافة المبنى لأنه خارج نطاق موقع المبنى الرئيسي للمنشأة",
        );
        setIsSubmitting(false);
        return;
      } else {
        setIsDuplicateRenin("");
      }

      if (
        !canAppendBuilding(
          declarationRequest?.unit?.building?.buildingProfile,
          declarationRequest?.unit,
          getMatchingBuildings(declarationRequest),
        )
      ) {
        setIsDuplicateRenin("لقد تمت إضافة هذا المبنى من قبل");
        isValid = false;
        setIsSubmitting(false);
        return;
      } else {
        setIsDuplicateRenin("");
        isValid = true;
      }

      if (
        !validateRequired(
          declarationRequest?.unit?.building?.buildingProfile?.renin,
        )
      ) {
        setUnitBuildingMapError("هذا العقار غير متاح برجاء اختيار عقار آخر");
        isValid = false;
      } else {
        setUnitBuildingMapError("");
        isValid = true;
      }

      if (declarationRequest?.unit?.building?.buildingProfile === null) {
        isValid = false;
      } else {
        isValid = true;
      }

      if (parseInt(building?.main_building) === 1) {
        const hasProfileNumber =
          !!declarationRequest?.unit?.buildingProfile?.number;
        const hasKnownNumber = !!declarationRequest?.unit?.known_build_num;

        if (!hasProfileNumber && !hasKnownNumber) {
          setIsDuplicateRenin(
            "لا يمكن إضافة المبنى لعدم توفر رقم العقار، برجاء تصحيح البيانات و إدخال رقم العقار/المبنى المتعارف عليه في قسم بيانات الموقع",
          );
          isValid = false;
        } else {
          setIsDuplicateRenin("");
          isValid = true;
        }
      }
    } else {
      isValid = true;
    }

    const isBuildingFormValid = validateBeforeSubmitBuilding();

    if (
      parseInt(building?.main_building) !== 1 &&
      building !== null &&
      building !== undefined
    ) {
      building.manual_known_build_num =
        building?.building_manual_known_build_num;
    }

    error_new_user?.buildings_count && setError("buildings_count", "");

    if (isBuildingFormValid && isValid) {
      if (!isBuildingHasDifferentSearchType && shouldShowModal) {
        return setShowDeleteOther(true);
      }
      const normalizedBuilding = ensureBuildingId({
        ...building,
        buildingProfile: declarationRequest?.unit?.building?.buildingProfile,
        known_build_num:
          parseInt(building?.main_building) === 1
            ? declarationRequest?.unit?.known_build_num
            : building?.known_build_num,
        filter_search_type: parseInt(
          declarationRequest?.unit?.filter_search_type_id,
        ),
        main_building:
          building?.main_building ||
          getMatchingBuildings(declarationRequest)?.length === 0 ||
          !isBuildingHasDifferentSearchType
            ? 1
            : 0,
      });

      if (declarationRequest?.unit?.id) {
        url = `api/declaration-system/declarations/${id}/units/building/hotel/${declarationRequest?.unit?.id}`;
        if (building?.id < 1) {
          delete building.id;
        }

        const data = {
          buildings_count: declarationRequest?.unit?.buildings_count,
          building: {
            ...building,
            ...(parseInt(declarationRequest?.unit?.filter_search_type_id) !== 3
              ? {
                  buildingProfile:
                    declarationRequest?.unit?.building?.buildingProfile,
                  filter_search_type: parseInt(
                    declarationRequest?.unit?.filter_search_type_id,
                  ),
                }
              : getManualCommonBuilding(
                  declarationRequest,
                  building?.main_building ||
                    getMatchingBuildings(declarationRequest)?.length === 0
                    ? 1
                    : 0,
                  building?.id,
                )),
          },
          unit: declarationRequest?.unit,
        };

        try {
          const response = await post(
            url,
            {
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
            },
            data,
          );

          setDeclarationRequest((prev) => ({
            ...prev,
            unit: {
              ...prev.unit,
              buildings: response?.data?.hotel_facility?.buildings,
              hotelUnits: response?.data?.hotel_facility?.hotelUnits,
            },
          }));
        } catch (error) {
          if (error.response?.data?.errors) {
            setSubmissionError(error.response?.data?.errors);
          } else {
            setBackendError(
              error.response?.data?.message ||
                error.response?.data?.data?.message ||
                "خطأ في إرسال البيانات",
            );
          }

          if (isBuildingEditMode && buildingsBeforeEdit) {
            setDeclarationRequest((prev) => ({
              ...prev,
              unit: {
                ...prev.unit,
                buildings: buildingsBeforeEdit,
              },
            }));
          }

          window.scrollTo(0, 0);
        }
      } else {
        setDeclarationRequest((prev) => ({
          ...prev,
          unit: {
            ...prev.unit,
            buildings: [
              ...(prev.unit?.buildings ?? []),
              {
                ...building,
                ...(parseInt(
                  declarationRequest?.unit?.filter_search_type_id,
                ) !== 3
                  ? normalizedBuilding
                  : getManualCommonBuilding(
                      declarationRequest,
                      building?.main_building ||
                        getMatchingBuildings(declarationRequest)?.length ===
                          0 ||
                        !isBuildingHasDifferentSearchType
                        ? 1
                        : 0,
                      normalizedBuilding?.id,
                    )),
              },
            ],
          },
        }));
      }

      // reset states
      setBuilding(null);
      setDeclarationRequest((prev) => ({
        ...prev,
        unit: { ...prev.unit, building: null },
      }));
      setIsBuildingEditMode(false);
    }
    setIsSubmitting(false);
  };

  const handleCancelBuilding = () => {
    setIsBuildingEditMode(false);
    setIsDuplicateRenin("");
    setEachErrorBuilding("is_map_address_matching", "");
    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...prev.unit,
        buildings: buildingsBeforeEdit || [],
        building: null,
      },
    }));
    setBuilding(null);
    setBuildingsBeforeEdit(null);
  };

  const resetErrorMessages = () => {
    setIsDuplicateRenin("");
    setUnitBuildingMapError("");
    setBackendError(null);
    setSubmissionError(null);
  };

  const handleEditBuilding = (buildingToBeEdited) => {
    if (parseInt(buildingToBeEdited?.main_building) !== 1) {
      buildingToBeEdited.building_manual_known_build_num =
        buildingToBeEdited?.manual_known_build_num ||
        buildingToBeEdited?.building_manual_known_build_num;
    }

    resetErrorMessages();
    setIsBuildingEditMode(true);
    setStaticBuilding(buildingToBeEdited);
    setBuildingsBeforeEdit(getMatchingBuildings(declarationRequest) || []);

    setBuilding(buildingToBeEdited);
    setDeclarationRequest((prev) => ({
      ...prev,
      unit: { ...prev.unit, building: buildingToBeEdited },
    }));

    deleteFromBuildings(buildingToBeEdited?.id, true);
  };

  const handleDeleteBuilding = async () => {
    const buildingId = idBuildingToBeDeleted;

    if (buildingId >= 1) {
      try {
        const url = `api/declaration-system/declarations/${declarationRequest?.id}/units/hotel/${declarationRequest?.unit?.id}/hotel_building/${buildingId}`;
        const response = await remove(url, {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
          },
        });

        setDeclarationRequest((prev) => ({
          ...prev,
          unit: response?.data?.hotel_facility,
        }));

        // TODO rese unit from response
      } catch (error) {
        console.error("Failed to delete building", error);
      }
    } else {
      deleteFromBuildings(buildingId);
    }
    setShowBuildingModal(false);
  };

  //working version without delete hotel units
  // const deleteFromBuildings = (buildingId) => {
  //   setDeclarationRequest((prev) => {
  //     const buildings = prev.unit?.buildings ?? [];
  //     const nextBuildings = buildings.filter((b) => b?.id !== buildingId);
  //     if (nextBuildings.length === buildings.length) return prev;
  //     return { ...prev, unit: { ...prev.unit, buildings: nextBuildings } };
  //   });
  // };

  //working version with delete hotel units
  const deleteFromBuildings = (buildingId, isLeaveHotelUnits = false) => {
    setDeclarationRequest((prev) => {
      const buildings = prev.unit?.buildings ?? [];
      const hotelUnits = prev.unit?.hotelUnits ?? [];
      // remove the building
      const nextBuildings = buildings.filter((b) => b?.id != buildingId);
      // remove hotelUnits linked to that building
      const nextHotelUnits = hotelUnits.filter(
        (u) => u?.building_id != buildingId,
      );

      // if nothing changed, return previous state
      if (
        nextBuildings.length === buildings.length &&
        nextHotelUnits.length === hotelUnits.length
      ) {
        return prev;
      }

      if (isLeaveHotelUnits) {
        return {
          ...prev,
          unit: {
            ...prev.unit,
            buildings: nextBuildings,
            // hotelUnits: nextHotelUnits,
          },
        };
      } else {
        return {
          ...prev,
          unit: {
            ...prev.unit,
            buildings: nextBuildings,
            hotelUnits: nextHotelUnits,
          },
        };
      }
    });
  };

  const generateBuildingOptions = (buildings = []) => {
    return (buildings || []).map((b) => {
      const profileNumber = b?.buildingProfile?.number;
      const knownNumber = b?.known_build_num;
      const manualNumber = b?.manual_known_build_num || b?.manual_renin;

      const isInvalidProfileNumber =
        profileNumber === null ||
        profileNumber === undefined ||
        profileNumber === "" ||
        profileNumber === "0" ||
        profileNumber === 0;

      const isInvalidKnownNumber =
        knownNumber === null ||
        knownNumber === undefined ||
        knownNumber === "" ||
        knownNumber === "0" ||
        knownNumber === 0;

      const label = !isInvalidKnownNumber
        ? knownNumber
        : !isInvalidProfileNumber
          ? profileNumber
          : parseInt(declarationRequest?.unit?.filter_search_type_id) === 3
            ? manualNumber
            : "—";

      return {
        value: String(b.id),
        label,
      };
    });
  };

  const resolveBuildingLabel = (buildingId) => {
    const b = (getMatchingBuildings(declarationRequest) || []).find(
      (b) => String(b?.id) === String(buildingId),
    );

    if (!b) return "—";
    // Priority: known_build_num first

    if (parseInt(declarationRequest?.unit?.filter_search_type_id) === 3) {
      return b?.manual_known_build_num || b?.manual_renin;
    } else {
      if (
        b?.known_build_num &&
        b?.known_build_num !== "" &&
        b?.known_build_num !== null
      ) {
        return b?.known_build_num;
      }

      // Then buildingProfile.number
      if (
        b?.buildingProfile?.number !== null &&
        b?.buildingProfile?.number !== "" &&
        b?.buildingProfile?.number != 0 // != catches both 0 and "0"
      ) {
        return b?.buildingProfile?.number;
      }
    }

    // Fallback
    return "—";
  };

  const buildingsCountLimit = Number.parseInt(
    declarationRequest?.unit?.buildings_count,
    10,
  );

  const hasReachedBuildingsLimit =
    editingHotelUnitIndex === null &&
    Number.isInteger(buildingsCountLimit) &&
    buildingsCountLimit > 0 &&
    (getMatchingHotelUnits(declarationRequest)?.length || 0) >=
      buildingsCountLimit;

  const handleChangeUnitFile = async (pc, c, key, value, i, bi, fi, ref) => {
    try {
      const labelMap = {
        copy_of_the_construction_permits: "building_permits",
        copy_of_the_operating_licenses: "operating_licenses",
        certificate_of_stardom_level: "certificate_of_stardom_level",
      };
      const label = labelMap[key] || key;
      const data = new FormData();
      data.append("label", label);
      data.append(`file`, value);

      if (value) {
        const response = await post(
          "api/declaration-system/declarations/upload-attachments",
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
            },
          },
          data,
        );

        updateDeclarationUnit(key, response?.data?.data);
        setError(key, "");
        setUploadFileError(null);
        setFileErrors((prev) => ({
          ...prev,
          [key]: "",
        }));

        if (location?.pathname?.includes("add") && !declarationRequest?.id) {
          setTempFiles((prev) => [...prev, response?.data?.data?.path]);
        }
      }
    } catch (error) {
      if (error.status === 422) {
        setValidFields((prev) => ({
          ...prev,
          key: false,
        }));
        updateDeclarationUnit(key, null);
        window.scrollTo(0, 0);
        setUploadFileError(error?.response?.data?.errors?.file);
        setFileErrors((prev) => ({
          ...prev,
          [key]: error?.response?.data?.errors?.file?.[0] || "خطأ في الملف",
        }));

        if (ref?.current) {
          ref.current.value = null;
        }
      }
    }
  };

  const handleLicenseDateChange = (pc, c, key, value) => {
    setLicenseDate(value);
    updateDeclarationUnit(
      "license_date",
      value ? Moment(value).format("YYYY-MM-DD") : null,
    );
  };

  const handleChangeHasSubUnits = (pc, c, key, value) => {
    const parsedValue =
      value === null || value === undefined || value === ""
        ? null
        : parseInt(value, 10);

    handleChangeDeclerationUnit(pc, c, key, parsedValue);
    if (parsedValue === 2) {
      updateDeclarationUnit("hotelUnits", []);
    }
  };

  const formFields = ({
    declarationRequest,
    error_new_user,
    handleChangeDeclerationUnit,
    stylesRequestData,
  }) => [
    {
      type: "input",
      colClass: "col-md-4",
      name: "trade_name",
      labelText: "الإسم التجاري للمنشأة الفندقية",
      placeholder: "ادخل الإسم التجاري..",
      labelHtmlFor: "trade_name",
      inputType: "text",
      maxLength: 100,
      allowedPattern: /^[A-Za-zء-غف-ي0-9\-_.\\/,\s]+$/,
      value: declarationRequest?.unit?.trade_name || "",
      disabled:
        declarationRequest?.viewMode || declarationRequest?.isUnitViewMode,
      onChange: handleChangeDeclerationUnit,
      errorText: error_new_user?.trade_name,
      stylesRequestData,
      required: true,
    },
    {
      type: "select",
      colClass: "col-md-4",
      name: "view_type_id",
      labelText: "الإطلالة",
      labelHtmlFor: "view_type_id",
      options: generateOptions(viewTypes),
      defaultText: "اختر الإطلالة..",
      value: declarationRequest?.unit?.view_type_id,
      disabled:
        declarationRequest?.viewMode || declarationRequest?.isUnitViewMode,
      onChange: handleChangeDeclerationUnit,
      errorText: error_new_user?.view_type_id,
      stylesRequestData,
      required: true,
      valueType: "string",
      isClearable: true,
    },
    {
      type: "input",
      colClass: "col-md-4",
      name: "buildings_count",
      labelText: "عدد المباني",
      placeholder: "ادخل عدد المباني..",
      labelHtmlFor: "buildings_count",
      inputType: "number",
      min: 1,
      step: 1,
      maxLength: 10,
      allowedPattern: /^[1-9]\d{0,9}$/,
      value: declarationRequest?.unit?.buildings_count || "",
      disabled:
        declarationRequest?.viewMode || declarationRequest?.isUnitViewMode,
      onChange: handleChangeDeclerationUnit,
      errorText: error_new_user?.buildings_count
        ? error_new_user?.buildings_count
        : addBuildingErrorMessage,
      stylesRequestData,
      required: true,
    },
    // {
    //   type: "input",
    //   colClass: "col-md-4",
    //   name: "rooms_count",
    //   labelText: "عدد الغرف",
    //   placeholder: "ادخل عدد الغرف..",
    //   labelHtmlFor: "rooms_count",
    //   inputType: "text",
    //   allowedPattern: /^[1-9]\d{0,9}$/,
    //   value: declarationRequest?.unit?.rooms_count || "",
    //   disabled:
    //     declarationRequest?.viewMode || declarationRequest?.isUnitViewMode,
    //   onChange: handleChangeDeclerationUnit,
    //   errorText: error_new_user?.rooms_count,
    //   stylesRequestData,
    //   required: true,
    // },
    {
      type: "select",
      colClass: "col-md-4",
      name: "star_rating_id",
      labelText: "مستوى النجومية",
      labelHtmlFor: "star_rating_id",
      options: generateOptions(starRatings),
      defaultText: "اختر مستوى النجومية..",
      value: declarationRequest?.unit?.star_rating_id,
      disabled:
        declarationRequest?.viewMode || declarationRequest?.isUnitViewMode,
      onChange: handleChangeDeclerationUnit,
      errorText: error_new_user?.star_rating_id,
      stylesRequestData,
      required: true,
      valueType: "string",
      isClearable: true,
    },
    {
      type: "select",
      colClass: "col-md-4",
      name: "has_sub_units",
      labelText: "هل توجد وحدات تابعة للمنشأة الفندقية؟",
      labelHtmlFor: "has_sub_units",
      options: generateOptions(doYouWantExtraAttachments),
      defaultText: "اختر..",
      value: declarationRequest?.unit?.has_sub_units ?? null,
      disabled:
        declarationRequest?.viewMode ||
        declarationRequest?.isUnitViewMode ||
        (getMatchingHotelUnits(declarationRequest)?.length || 0) > 0,
      onChange: handleChangeHasSubUnits,
      errorText: error_new_user?.has_sub_units,
      stylesRequestData,
      required: true,
      isClearable: true,
    },
  ];

  const fields = formFields({
    declarationRequest,
    error_new_user,
    handleChangeDeclerationUnit,
    generateOptions,
    stylesRequestData,
  });

  const maxLicenseDate = declarationRequest?.created_at
    ? new Date(declarationRequest?.created_at)
    : new Date();

  const handleUpdateHotelUnit = (field, value) => {
    setCurrentHotelUnit((prev) => {
      const updated = {
        ...prev,
        [field]: value,
      };

      if (field === "floor_number_id" && value) {
        const numericId = parseInt(value, 10);
        if (!Number.isNaN(numericId)) {
          updated.floor_number_id = String(numericId);
        }
      }

      if (field === "inside_operation_license") {
        if (parseInt(value) !== 2) {
          updated.reta_contact_about_unit = "";
          updated.account_code = "";
          updated.market_price = "";
          updated.annual_rent = "";
        }
      }

      if (field === "reta_contact_about_unit") {
        if (parseInt(value) !== 1) {
          updated.account_code = "";
        }
      }

      return updated;
    });

    if (hotelUnitErrors[field]) {
      setHotelUnitErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  const validateHotelUnit = () => {
    let hasErrors = false;
    const errors = {
      building_number: "",
      floor_number_id: "",
      floor_number_other: "",
      unit_number: "",
      activity_type: "",
      area: "",
      inside_operation_license: "",
      reta_contact_about_unit: "",
      account_code: "",
      market_price: "",
      annual_rent: "",
    };

    const selectedBuilding = getMatchingBuildings(declarationRequest)?.find(
      (b) => String(b.id) === String(currentHotelUnit.building_id),
    );

    if (
      !validateRequired(selectedBuilding?.buildingProfile?.number) &&
      !validateRequired(selectedBuilding?.known_build_num) &&
      !validateRequired(selectedBuilding?.manual_known_build_num)
    ) {
      errors.building_id =
        "لا يمكن إضافة المبنى لعدم توفر رقم العقار، برجاء تصحيح البيانات و إدخال رقم العقار/المبنى المتعارف عليه في قسم بيانات الموقع";
      hasErrors = true;
    }

    // todo get building by builidingId, and check the value of 3aqar and 3aqar mot3arf 3aleh
    if (!validateRequired(currentHotelUnit.building_id)) {
      errors.building_id = "يجب اختيار رقم المبنى";
      hasErrors = true;
    }

    if (!validateRequired(currentHotelUnit.floor_number_id)) {
      errors.floor_number_id = "يجب اختيار رقم الدور";
      hasErrors = true;
    }

    if (
      currentHotelUnit.floor_number_id == -1 &&
      !validateRequired(currentHotelUnit.floor_number_other)
    ) {
      errors.floor_number_other = "يجب اختيار رقم الدور الآخر";
      hasErrors = true;
    }

    if (!validateRequired(currentHotelUnit.unit_number)) {
      errors.unit_number = "يجب ادخال رقم الوحدة";
      hasErrors = true;
    }

    if (!validateRequired(currentHotelUnit.activity_type)) {
      errors.activity_type = "يجب ادخال نوع النشاط";
      hasErrors = true;
    }

    if (!validateRequired(currentHotelUnit.area)) {
      errors.area = "يجب ادخال المساحة";
      hasErrors = true;
    }

    if (!validateRequired(currentHotelUnit.inside_operation_license)) {
      errors.inside_operation_license = "يجب اختيار إجابة";
      hasErrors = true;
    }

    if (String(currentHotelUnit.inside_operation_license) === "2") {
      if (!validateRequired(currentHotelUnit.reta_contact_about_unit)) {
        errors.reta_contact_about_unit = "يجب اختيار إجابة";
        hasErrors = true;
      }

      if (
        currentHotelUnit.account_code &&
        !/^\d{14}$/.test(String(currentHotelUnit.account_code))
      ) {
        errors.account_code = "كود حساب الوحدة يجب أن يكون 14 رقمًا";
        hasErrors = true;
      }
    }

    if (hasErrors) {
      setHotelUnitErrors(errors);
      return false;
    }

    return true;
  };

  const validateUnitFloor = () => {
    const unit = currentHotelUnit;
    const buildings = getMatchingBuildings(declarationRequest);
    const hotelUnits = getMatchingHotelUnits(declarationRequest);
    if (!unit || !buildings) return true;

    // find the building this unit belongs to
    const building = buildings?.find(
      (b) => String(b.id) === String(unit.building_id),
    );
    if (!building) return true;

    const buildingFloors = parseInt(building.floors_number ?? 0, 10);
    // if floors_number is not defined or <= 0, skip validation
    if (!buildingFloors || isNaN(buildingFloors)) {
      setAddHotelUnitErrorMessage("");
      return true;
    }

    // collect distinct floor ids already used for this building
    const usedFloors = new Set(
      hotelUnits
        ?.filter((u) => String(u.building_id) === String(unit.building_id))
        ?.map((u) => String(u.floor_number_id)),
    );

    // add the floor of the unit being added/edited
    usedFloors.add(String(unit.floor_number_id));

    if (usedFloors.size > buildingFloors) {
      setAddHotelUnitErrorMessage(
        "لقد تخطيت عدد الأدوار التي قمت بإدخالها للمبنى",
      );
      return false;
    }

    setAddHotelUnitErrorMessage("");
    return true;
  };

  const handleAddHotelUnit = async () => {
    let newUnits;
    const url = `api/declaration-system/declarations/${id}/units/hotel/${declarationRequest?.unit?.id}/${currentHotelUnit.building_id}`;

    setAddHotelUnitErrorMessage("");
    error_new_user?.buildings_count && setError("buildings_count", "");
    // if (hasReachedBuildingsLimit) {
    //   setAddHotelUnitErrorMessage(
    //     "يجب أن يكون عدد المباني أكبر من إجمالي المباني المُدخلة أو مساويًا لها",
    //   );
    //   return;
    // }

    if (!validateHotelUnit()) {
      return;
    }

    if (validateUnitFloor()) {
      const insideOperationLicenseValue =
        parseInt(currentHotelUnit.inside_operation_license) === 1 ? 1 : 2;

      const normalizedUnit = {
        ...(currentHotelUnit?.id
          ? { id: currentHotelUnit.id }
          : { id: Math.random() }),
        property_type_id: declarationRequest?.unit?.property_type_id,
        property_type_text: declarationRequest?.unit?.property_type_text,
        declaration_id: declarationRequest?.unit?.declaration_id,
        building_id: currentHotelUnit.building_id,
        building_number: getBuildingNumberById(currentHotelUnit.building_id),
        floor_number_id: currentHotelUnit.floor_number_id,
        floor_number_other: currentHotelUnit.floor_number_other || "",
        unit_number: currentHotelUnit.unit_number,
        activity_type: currentHotelUnit.activity_type,
        area: currentHotelUnit.area,
        inside_operation_license: insideOperationLicenseValue,
        filter_search_type: declarationRequest?.unit?.filter_search_type_id,
      };

      if (insideOperationLicenseValue === 2) {
        normalizedUnit.reta_contact_about_unit =
          parseInt(currentHotelUnit.reta_contact_about_unit) === 1 ? 1 : 2;
        normalizedUnit.account_code = currentHotelUnit.account_code;
        normalizedUnit.market_price = currentHotelUnit.market_price;
        normalizedUnit.annual_rent = currentHotelUnit.annual_rent;
      }

      const existingUnits = getMatchingHotelUnits(declarationRequest) || [];
      const unitsWithDefaultEditFlag = existingUnits?.map((unit) => ({
        ...unit,
        is_edit: false,
      }));

      if (declarationRequest?.unit?.id) {
        if (currentHotelUnit?.id < 1) {
          delete currentHotelUnit.id;
          delete normalizedUnit.id;
        }

        const data = {
          hotelUnit: normalizedUnit,
        };

        try {
          const response = await post(
            url,
            {
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
            },
            data,
          );

          newUnits = response?.data?.hotelUnits;
        } catch (error) {
          newUnits = unitsWithDefaultEditFlag;
        }
      } else {
        newUnits = [
          ...unitsWithDefaultEditFlag,
          { ...normalizedUnit, is_edit: false },
        ];
      }

      updateDeclarationUnit("hotelUnits", newUnits);

      setCurrentHotelUnit({
        id: null,
        building_number: "",
        floor_number_id: "",
        floor_number_other: "",
        unit_number: "",
        activity_type: "",
        area: "",
        inside_operation_license: "",
        reta_contact_about_unit: "",
        account_code: "",
        market_price: "",
        annual_rent: "",
      });
      setEditingHotelUnitIndex(null);
      setHotelUnitErrors({
        building_number: "",
        floor_number_id: "",
        floor_number_other: "",
        unit_number: "",
        activity_type: "",
        area: "",
        inside_operation_license: "",
        reta_contact_about_unit: "",
        account_code: "",
        market_price: "",
        annual_rent: "",
      });
      setAddHotelUnitErrorMessage("");
    }
  };

  const handleRemoveHotelUnit = async (unitToDelete, index) => {
    const isUpdateMode =
      declarationRequest?.editMode || declarationRequest?.isUnitEditMode;
    const declarationId = declarationRequest?.id;
    const hotelFacilityUnitId = declarationRequest?.unit?.id;
    const hotelUnitId = unitToDelete?.id;

    if (
      isUpdateMode &&
      declarationId &&
      hotelFacilityUnitId &&
      hotelUnitId &&
      Number(hotelUnitId) >= 1
    ) {
      try {
        const url = `api/declaration-system/declarations/${declarationId}/units/hotel/${hotelFacilityUnitId}/hotel_unit/${hotelUnitId}`;
        await remove(url, {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
          },
        });
      } catch (error) {
        console.error("Failed to delete hotel unit", error);
        setAddHotelUnitErrorMessage("تعذر حذف الوحدة، حاول مرة أخرى");
        return false;
      }
    }

    const updated = (getMatchingHotelUnits(declarationRequest) || []).filter(
      (_, idx) => idx !== index,
    );
    updateDeclarationUnit("hotelUnits", updated);

    if (editingHotelUnitIndex === index) {
      setEditingHotelUnitIndex(null);
      setCurrentHotelUnit({
        id: null,
        building_number: "",
        floor_number_id: "",
        unit_number: "",
        activity_type: "",
        area: "",
        inside_operation_license: "",
        reta_contact_about_unit: "",
        account_code: "",
        market_price: "",
        annual_rent: "",
      });
    }

    setAddHotelUnitErrorMessage("");
    return true;
  };

  const openDeleteHotelUnitModal = (unitToDelete, index) => {
    setHotelUnitToDelete(unitToDelete);
    setHotelUnitIndexToDelete(index);
    setShowModal(true);
  };

  const closeDeleteHotelUnitModal = () => {
    setShowModal(false);
    setHotelUnitToDelete(null);
    setHotelUnitIndexToDelete(null);
  };

  const handleConfirmDeleteHotelUnit = async () => {
    if (hotelUnitIndexToDelete === null) return;
    const isDeleted = await handleRemoveHotelUnit(
      hotelUnitToDelete,
      hotelUnitIndexToDelete,
    );

    if (isDeleted) {
      closeDeleteHotelUnitModal();
    }
  };

  const getBuildingNumberById = (id) => {
    const building = getMatchingBuildings(declarationRequest).find(
      (b) => b.id == id,
    );
    return (
      building?.buildingProfile?.number ||
      building?.known_build_num ||
      building?.manual_known_build_num
    );
  };

  const handleEditHotelUnit = (unitToEdit, id) => {
    setStaticHotelUnit(unitToEdit);
    if (!unitToEdit) return;
    setEditingHotelUnitIndex(id);

    setDeclarationRequest((prev) => {
      const nextHotelUnits = prev?.unit?.hotelUnits?.filter(
        (b) => b?.id !== id,
      );

      // If nothing changed, return prev to avoid unnecessary re-renders
      if (
        nextHotelUnits.length ===
        getMatchingHotelUnits(declarationRequest)?.length
      )
        return prev;

      return {
        ...prev,
        unit: {
          ...prev.unit,
          hotelUnits: nextHotelUnits,
        },
      };
    });

    let floorId = unitToEdit.floor_number_id;
    if (floorId && !Number.isNaN(parseInt(floorId, 10))) {
      floorId = String(parseInt(floorId, 10));
    }

    setCurrentHotelUnit({
      id: unitToEdit.id || null,
      building_id: unitToEdit.building_id || "",
      building_number: getBuildingNumberById(unitToEdit.building_id) || "",
      floor_number_id: floorId || "",
      unit_number: unitToEdit.unit_number || "",
      floor_number_other: unitToEdit.floor_number_other || "",
      activity_type: unitToEdit.activity_type || "",
      area: unitToEdit.area || "",
      inside_operation_license: unitToEdit.inside_operation_license || "",
      reta_contact_about_unit: unitToEdit.reta_contact_about_unit || "",
      account_code: unitToEdit.account_code || "",
      market_price: unitToEdit.market_price || "",
      annual_rent: unitToEdit.annual_rent || "",
    });
    setHotelUnitErrors({
      building_number: "",
      floor_number_id: "",
      floor_number_other: "",
      unit_number: "",
      activity_type: "",
      area: "",
      inside_operation_license: "",
      reta_contact_about_unit: "",
      account_code: "",
      market_price: "",
      annual_rent: "",
    });
  };

  const handleCancelHotelUnit = () => {
    // setCurrentHotelUnit(staticHotelUnit);
    setEditingHotelUnitIndex(null);
    setCurrentHotelUnit({
      id: null,
      building_number: "",
      floor_number_id: "",
      floor_number_other: "",
      unit_number: "",
      activity_type: "",
      area: "",
      inside_operation_license: "",
      reta_contact_about_unit: "",
      account_code: "",
      market_price: "",
      annual_rent: "",
    });
    setHotelUnitErrors({
      building_number: "",
      floor_number_id: "",
      floor_number_other: "",
      unit_number: "",
      activity_type: "",
      area: "",
      inside_operation_license: "",
      reta_contact_about_unit: "",
      account_code: "",
      market_price: "",
      annual_rent: "",
    });
    setAddHotelUnitErrorMessage("");
    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...prev.unit,
        hotelUnits: [...(prev.unit?.hotelUnits ?? []), staticHotelUnit],
        currentHotelUnit: null,
      },
    }));
  };

  const resolveFloorLabel = (floorId) => {
    const floorItem = (realFloorOther || []).find(
      (floor) => String(floor?.id) === String(floorId),
    );
    return floorItem?.name || floorItem?.label || floorId;
  };

  const attachedEssentialDocuments = [
    {
      key: "copy_of_the_construction_permits",
      label: "مرفق التراخيص الإنشائية",
      file: declarationRequest?.unit?.copy_of_the_construction_permits,
    },
    {
      key: "copy_of_the_operating_licenses",
      label: "مرفق تراخيص التشغيل",
      file: declarationRequest?.unit?.copy_of_the_operating_licenses,
    },
    {
      key: "certificate_of_stardom_level",
      label: "مرفق شهادة مستوى النجومية",
      file: declarationRequest?.unit?.certificate_of_stardom_level,
    },
  ].filter((document) => document.file !== null && document.file !== undefined);

  const handleDeleteAllManualBuildings = async () => {
    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...prev.unit,
        buildings: [],
        hotelUnits: [],
      },
    }));

    handleAddBuilding(false);
    setShowDeleteOther(false);
  };

  return (
    <>
      {/* Hotel unit delete modal */}
      <Modal
        isOpen={showModal}
        onRequestClose={closeDeleteHotelUnitModal}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        overlayClassName={stylesModal.overlay}
        className={stylesModal.content}
      >
        <div className="col-lg-8 text-center">
          <h5>هل أنت متأكد من حذف هذه الوحدة</h5>
          <div className="d-flex gap-4 justify-content-center">
            <button
              className="btn btn-primary px-3"
              onClick={handleConfirmDeleteHotelUnit}
            >
              نعم
            </button>
            <button
              className="btn btn-danger px-3"
              onClick={closeDeleteHotelUnitModal}
            >
              لا
            </button>
          </div>
        </div>
      </Modal>

      {/* Building delete modal */}
      <Modal
        isOpen={showBuildingModal}
        onRequestClose={() => setShowBuildingModal(false)}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        overlayClassName={stylesModal.overlay}
        className={stylesModal.content}
      >
        <div className="col-lg-8 text-center">
          <h5>
            هل أنت متأكد من حذف هذا المبنى؟ في حالة وجود وحدات تابعة للمنشأة
            الفندقية تمت إضافتها لهذا المبنى سيتم حذفها
          </h5>
          <div className="d-flex gap-4 justify-content-center">
            <button
              className="btn btn-primary px-3"
              onClick={handleDeleteBuilding}
            >
              نعم
            </button>
            <button
              className="btn btn-danger px-3"
              onClick={() => setShowBuildingModal(false)}
            >
              لا
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={showDeleteOther}
        onRequestClose={() => {
          setShowDeleteOther(false);
          setIsSubmitting(false);
        }}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        overlayClassName={stylesModal.overlay}
        className={stylesModal.content}
      >
        <div className="col-lg-8 text-center">
          <h5>
            في حالة تأكيد إضافة المبنى الرئيسي بإستخدام وسيلة عنوان أخرى غير
            المُدخلة مسبقا سيتم حذف المباني الأخرى نظرا لتغيير طريقة ادخال عنوان
            المبنى الرئيسي للمنشأة و سيتم حذف الوحدات التابعة - إن وجدت - و يجب
            إعادة استكمال بيانات المبنى الرئيسي في قسم وصف المباني ثم إضافة
            المبنى لإستكمال عملية إضافة العقار
          </h5>
          <div className="d-flex gap-4 justify-content-center">
            <button
              className="btn btn-primary px-3"
              onClick={handleDeleteAllManualBuildings}
            >
              نعم
            </button>
            <button
              className="btn btn-danger px-3"
              onClick={() => {
                setShowDeleteOther(false);
                setIsSubmitting(false);
              }}
            >
              لا
            </button>
          </div>
        </div>
      </Modal>

      {fields.slice(0, 2).map((field) => (
        <FieldRenderer key={field.name} field={field} />
      ))}

      {declarationRequest?.viewMode || declarationRequest?.isUnitViewMode ? (
        <div className="col-lg-4 col-sm-6">
          <InputElement
            value={declarationRequest?.unit?.license_date}
            disabled={true}
            name="license_date"
            mb4="mb-4"
            labelHtmlFor="license_date"
            labelClassName={` ${stylesRequestData["form-label"]} form-label`}
            labelText="تاريخ تراخيص التشغيل"
            inputType="text"
            inputClassName={`${stylesRequestData["form-control"]} form-control`}
            inputID="license_date_input"
            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
          />
        </div>
      ) : (
        <div className="col-lg-4 col-sm-6">
          <DatePickerFormatedWithLimit
            name="licenseDate"
            name_datepicker="licenseDate"
            mb4="mb-4"
            labelHtmlFor="licenseDate"
            labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
            labelText="تاريخ تراخيص التشغيل"
            inputType="datePicker"
            maxDate={maxLicenseDate}
            inputClassName="form-control"
            inputID="license_date_input"
            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
            pText={error_new_user.license_date}
            value={licenseDate}
            placeholderText="تاريخ تراخيص التشغيل"
            onChange={handleLicenseDateChange}
            isDisabled={!canEditUnit}
          />
        </div>
      )}

      {fields.slice(2).map((field) => (
        <FieldRenderer key={field.name} field={field} />
      ))}

      {/* ── Building section ─────────────────────────────────────────────── */}
      <div className="row">
        <div className="d-flex align-items-center mb-4">
          <div className="d-flex align-items-center mb-4">
            <h4 className={`${stylesRequestData["box-title"]} box-title mb-0`}>
              وصف المباني
            </h4>
          </div>
        </div>

        {canEditUnit && (
          <>
            <CommonAddressMap
              hasNoContainer={true}
              mapType={"building"}
              NoRender={false}
              unitBuildingMapError={unitBuildingMapError}
              setUnitBuildingMapError={setUnitBuildingMapError}
              isMainBuilding={parseInt(building?.main_building) === 1}
            />

            {/* <div className="col-lg-4 col-sm-6">
              <InputElement
                mb4="mb-4"
                labelHtmlFor="known_build_num"
                labelClassName={` ${stylesRequestData["form-label"]} form-label`}
                labelText="رقم العقار/المبنى المتعارف عليه"
                inputType="text"
                maxLength={100}
                inputClassName={`${stylesRequestData["form-control"]} form-control`}
                inputID="known_build_num_input"
                name="known_build_num"
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                value={building?.known_build_num || ""}
                allowedPattern={
                  /^(?!0)[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.\/\\\s]+$/
                }
                onChange={handleUpdateBuilding}
                pText={errorBuilding.known_build_num}
                disabled={
                  declarationRequest?.viewMode ||
                  declarationRequest?.isUnitViewMode
                }
              />
            </div> */}

            <div className="col-lg-4 col-sm-6">
              <InputElement
                mb4="mb-4"
                labelHtmlFor="rooms_number"
                labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
                labelText="عدد الغرف"
                placeholder="ادخل عدد الغرف .."
                inputType="number"
                min={1}
                step={1}
                maxLength={10}
                inputClassName={`${stylesRequestData["form-control"]} form-control`}
                inputID="rooms_number_input"
                name="rooms_number"
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                value={building?.rooms_number || ""}
                pattern="[1-9][0-9]{0,9}"
                onChange={handleUpdateBuilding}
                pText={errorBuilding.rooms_number}
                disabled={
                  declarationRequest?.viewMode ||
                  declarationRequest?.isUnitViewMode
                }
              />
            </div>

            <div className="col-lg-4 col-sm-6">
              <InputElement
                mb4="mb-4"
                labelHtmlFor="floors_number"
                labelClassName={` ${stylesRequestData["form-label"]} form-label`}
                labelText="عدد الأدوار"
                inputType="number"
                min={1}
                step={1}
                maxLength={10}
                inputClassName={`${stylesRequestData["form-control"]} form-control`}
                inputID="floors_number_input"
                name="floors_number"
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                value={building?.floors_number || ""}
                allowedPattern={/^[1-9]\d{0,9}$/}
                onChange={handleUpdateBuilding}
                pText={errorBuilding.floors_number}
                disabled={
                  declarationRequest?.viewMode ||
                  declarationRequest?.isUnitViewMode
                }
              />
            </div>

            <div className="d-flex flex-lg-row flex-column gap-3 align-items-start ">
              <div className="d-flex flex-column">
                <div className="d-flex align-items-center gap-3 flex-wrap">
                  <button
                    type="button"
                    className={
                      isAddBuildingButtonDisabled || isSubmitting
                        ? stylesRequestData["btn-add-disabled"]
                        : stylesRequestData["btn-add"]
                    }
                    onClick={() => handleAddBuilding(true)}
                    id="submit_request_data"
                  >
                    {isBuildingEditMode ? "حفظ" : "إضافة مبنى"}
                  </button>

                  {!isBuildingEditMode && (
                    <div className="d-inline-flex align-items-center gap-2">
                      <InfoPopover content="لإضافة مبنى آخر برجاء زيادة عدد المباني في قسم بيانات المنشأة">
                        <img
                          src={infoIconSvg}
                          alt="info"
                          width="18"
                          height="18"
                          style={{ display: "block" }}
                        />
                      </InfoPopover>
                    </div>
                  )}
                </div>
              </div>

              {isBuildingEditMode && (
                <div>
                  <button
                    type="button"
                    className={stylesRequestData["btn-cancel-building"]}
                    onClick={handleCancelBuilding}
                  >
                    إلغاء
                  </button>
                </div>
              )}
            </div>
            <div className="w-100 mt-1 pb-3">
              {isDuplicateRenin !== "" && (
                <p className="text-danger mb-0  me-2 fw-bolder">
                  {isDuplicateRenin}
                </p>
              )}
            </div>
          </>
        )}
      </div>

      {/* Buildings table */}
      {getMatchingBuildings(declarationRequest)?.length > 0 && (
        <div
          className={`${stylesRequestData["table-responsive"]} table-responsive`}
        >
          <table className="table table-striped">
            <thead>
              <tr>
                <th>المحافظة</th>
                <th>عنوان العقار</th>
                <th>الرقم القومي العقاري للمبنى</th>
                {/* <th>رقم العقار/المبنى المتعارف عليه</th> */}
                <th>العنوان مطابق لعنوان العقار محل الإقرار</th>
                <th>سبب عدم تطابق البيانات</th>
                <th>عدد الغرف</th>
                <th>عدد الأدوار</th>
                {canEditUnit && <th> </th>}
              </tr>
            </thead>
            <tbody>
              {getMatchingBuildings(declarationRequest)?.map((b, idx) => (
                <tr key={b?.id ?? `building-${idx}`}>
                  <td data-label="المحافظة">
                    {b?.buildingProfile?.address?.goveronrate ||
                      b?.governorate_text ||
                      getLabelById(b?.manual_governorate_id, staticGovs) ||
                      "—"}
                  </td>
                  <td data-label="عنوان العقار">
                    {(b?.mismatch_reason_id || b?.correct_astrick_colour) && (
                      <span
                        className="mr-1"
                        style={{
                          color:
                            parseInt(b?.mismatch_reason_id) === 1
                              ? "green"
                              : parseInt(b?.mismatch_reason_id) === 2
                                ? "blue"
                                : parseInt(b?.mismatch_reason_id) === 3
                                  ? "red"
                                  : "orange",
                        }}
                      >
                        *
                      </span>
                    )}
                    {buildingFullAddressDisplay(
                      b?.buildingProfile,
                      declarationRequest?.unit?.buildings[idx],
                    )}
                  </td>
                  <td data-label="الرقم القومي العقاري للمبنى">
                    {b?.buildingProfile?.renin || b?.manual_renin || "—"}
                  </td>
                  {/* <td data-label="رقم العقار/المبنى المتعارف عليه">
                    {b?.known_build_num || "—"}
                  </td> */}
                  <td data-label="العنوان مطابق لعنوان العقار محل الإقرار">
                    {getLabelById(
                      b?.is_map_address_matching,
                      DoYouWantExtraAttachmentsForRequestTypes,
                    ) || "—"}
                  </td>
                  <td data-label="سبب عدم تطابق البيانات">
                    {getLabelById(
                      b?.mismatch_reason_id,
                      dataMismatchReasonLookup,
                    ) || "—"}
                  </td>

                  <td data-label="عدد الغرف">{b?.rooms_number ?? "—"}</td>
                  <td data-label="عدد الأدوار">
                    {!b?.floors_number ? "—" : b.floors_number}
                  </td>
                  {canEditUnit && (
                    <td data-label="إجراءات">
                      <div
                        className={`d-flex ${stylesRequestData["action-buttons-small-screen"]}`}
                      >
                        <div
                          className={`${stylesRequestData["action-buttons"]}`}
                        >
                          <button
                            type="button"
                            className={`${stylesRequestData["btn-edit"]}`}
                            onClick={() => handleEditBuilding(b)}
                            disabled={
                              isBuildingEditMode ||
                              hasFilterSearchTypeMismatch(declarationRequest)
                            }
                            title="تعديل المبنى"
                          >
                            <i className="fa-solid fa-pen-to-square"></i>
                          </button>
                          {getMatchingBuildings(declarationRequest)?.length >
                            1 &&
                            parseInt(b?.main_building) !== 1 && (
                              <button
                                type="button"
                                className={`${stylesRequestData["btn-delete-icon"]}`}
                                onClick={() => {
                                  setIdBuildingToBeDeleted(b?.id);
                                  setShowBuildingModal(true);
                                }}
                                title="حذف المبنى"
                                disabled={isBuildingEditMode}
                              >
                                <i className="fa-solid fa-trash-can"></i>
                              </button>
                            )}
                        </div>
                      </div>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* ── Hotel sub-units section ──────────────────────────────────────── */}
      {parseInt(declarationRequest?.unit?.has_sub_units) === 1 && (
        <>
          <div className="row">
            <div className="col-12 d-flex justify-content-between align-items-center">
              <h4
                className={`${stylesRequestData["box-title"]} box-title mb-4 mt-3`}
              >
                الوحدات التابعة للمنشأة الفندقية
              </h4>
            </div>
          </div>

          {canEditUnit && (
            <>
              <div className="row">
                {/* Building number dropdown – populated from buildings list */}
                <div className="col-lg-4 col-sm-6">
                  <SearchSelectElement
                    mb4="mb-4"
                    labelHtmlFor="building_id"
                    labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                    labelText="رقم المبنى"
                    selectClassName={`${stylesRequestData["form-select"]} form-select`}
                    selectID="building_id"
                    inputId="building_id_input"
                    name="building_id"
                    options={generateBuildingOptions(
                      getMatchingBuildings(declarationRequest),
                    )}
                    default="اختر رقم المبنى.."
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    pText={hotelUnitErrors?.building_id}
                    value={currentHotelUnit.building_id}
                    onChange={(pc, c, key, value) => {
                      handleUpdateHotelUnit("building_id", value);
                    }}
                    isClearable={true}
                    disabled={!canEditUnit}
                  />
                </div>
                <div className="col-lg-4 col-sm-6">
                  <SearchSelectElement
                    mb4="mb-4"
                    labelHtmlFor="floor_number_id"
                    labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                    labelText="رقم الدور"
                    selectClassName={`${stylesRequestData["form-select"]} form-select`}
                    selectID="floor_number_id"
                    inputId="floor_number_id_input"
                    name="floor_number_id"
                    options={generateOptions(realFloorOther || [])}
                    default="أختار رقم الدور.."
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    pText={hotelUnitErrors?.floor_number_id}
                    value={currentHotelUnit.floor_number_id}
                    onChange={(pc, c, key, value) =>
                      handleUpdateHotelUnit("floor_number_id", value)
                    }
                    isClearable={true}
                    disabled={!canEditUnit}
                  />
                </div>
                {parseInt(currentHotelUnit?.floor_number_id) === -1 && (
                  <div className="col-lg-4 col-sm-6">
                    <InputElement
                      mb4="mb-4"
                      labelHtmlFor="floor_number_other"
                      labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
                      labelText="رقم الدور الآخر"
                      inputType="text"
                      maxLength={100}
                      inputClassName={`${stylesRequestData["form-control"]} form-control`}
                      inputID="floor_number_other_input"
                      name="floor_number_other"
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      value={currentHotelUnit?.floor_number_other || ""}
                      allowedPattern={
                        /^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.+،\/\\\s]+$/
                      }
                      onChange={(pc, c, key, value) =>
                        handleUpdateHotelUnit("floor_number_other", value)
                      }
                      pText={hotelUnitErrors.floor_number_other}
                      disabled={!canEditUnit}
                    />
                  </div>
                )}
                <div className="col-lg-4 col-sm-6">
                  <InputElement
                    mb4="mb-4"
                    labelHtmlFor="unit_number"
                    labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                    labelText="رقم الوحدة"
                    inputType="text"
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputID="unit_number"
                    name="unit_number"
                    allowedPattern={/^[1-9]\d{0,9}$/}
                    placeholder="ادخل رقم الوحدة.."
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    value={currentHotelUnit.unit_number || ""}
                    onChange={(pc, c, key, value) =>
                      handleUpdateHotelUnit("unit_number", value)
                    }
                    pText={hotelUnitErrors?.unit_number}
                    disabled={!canEditUnit}
                  />
                </div>

                <div className="col-lg-4 col-sm-6">
                  <InputElement
                    mb4="mb-4"
                    labelHtmlFor="activity_type"
                    labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                    labelText="نوع النشاط"
                    inputType="text"
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputID="activity_type"
                    name="activity_type"
                    maxLength={100}
                    allowedPattern={
                      /^(?!.*[0-9])[A-Za-z\u0621-\u063A\u0641-\u064A\-_,.\/\\\s]+$/
                    }
                    placeholder="ادخل نوع النشاط.."
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    value={currentHotelUnit.activity_type || ""}
                    onChange={(pc, c, key, value) =>
                      handleUpdateHotelUnit("activity_type", value)
                    }
                    pText={hotelUnitErrors?.activity_type}
                    disabled={!canEditUnit}
                  />
                </div>
                <div className="col-lg-4 col-sm-6">
                  <InputElement
                    mb4="mb-4"
                    labelHtmlFor="area"
                    labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                    labelText="المساحة"
                    inputType="text"
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputID="area"
                    name="area"
                    allowedPattern={
                      /^(?!0+(?:\.0{0,2})?$)\d{1,7}(?:\.\d{0,2})?$/
                    }
                    placeholder="ادخل المساحة.."
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    value={currentHotelUnit.area || ""}
                    onChange={(pc, c, key, value) =>
                      handleUpdateHotelUnit("area", value)
                    }
                    pText={hotelUnitErrors?.area}
                    disabled={!canEditUnit}
                  />
                </div>
                <div className="col-lg-4 col-sm-6">
                  <SearchSelectElement
                    mb4="mb-4"
                    labelHtmlFor="inside_operation_license"
                    labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                    labelText="داخل رخصة التشغيل؟"
                    selectClassName={`${stylesRequestData["form-select"]} form-select`}
                    selectID="inside_operation_license"
                    inputId="inside_operation_license_input"
                    name="inside_operation_license"
                    options={generateOptions(doYouWantExtraAttachments)}
                    default="اختر.."
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    pText={hotelUnitErrors?.inside_operation_license}
                    value={currentHotelUnit.inside_operation_license}
                    onChange={(pc, c, key, value) =>
                      handleUpdateHotelUnit("inside_operation_license", value)
                    }
                    isClearable={true}
                    disabled={!canEditUnit}
                  />
                </div>
              </div>

              {parseInt(currentHotelUnit.inside_operation_license) === 2 && (
                <>
                  <div className="col-lg-4 col-sm-6">
                    <SearchSelectElement
                      mb4="mb-4"
                      labelHtmlFor="reta_contact_about_unit"
                      labelClassName={` required form-label ${stylesRequestData["form-label"]} ${stylesRequestData["smaller-label"]}`}
                      labelText="هل تم التواصل مع الضرائب العقارية بخصوص الوحدة محل الإقرار سابقا؟"
                      selectClassName={`${stylesRequestData["form-select"]} form-select`}
                      selectID="reta_contact_about_unit"
                      inputId="reta_contact_about_unit_input"
                      name="reta_contact_about_unit"
                      options={generateOptions(doYouWantExtraAttachments)}
                      default="اختر.."
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      pText={hotelUnitErrors?.reta_contact_about_unit}
                      value={currentHotelUnit.reta_contact_about_unit}
                      onChange={(pc, c, key, value) =>
                        handleUpdateHotelUnit("reta_contact_about_unit", value)
                      }
                      isClearable={true}
                      disabled={!canEditUnit}
                    />
                  </div>
                  {parseInt(currentHotelUnit.reta_contact_about_unit) === 1 && (
                    <div className="col-lg-4 col-sm-6">
                      <InputElement
                        mb4="mb-4"
                        labelHtmlFor="account_code"
                        labelClassName={`form-label ${stylesRequestData["form-label"]}`}
                        labelText="كود حساب الوحدة"
                        inputType="text"
                        inputClassName={`${stylesRequestData["form-control"]} form-control`}
                        inputID="account_code"
                        name="account_code"
                        maxLength="14"
                        allowedPattern={/^\d{0,14}$/}
                        placeholder="ادخل كود حساب الوحدة.."
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        value={currentHotelUnit.account_code || ""}
                        onChange={(pc, c, key, value) =>
                          handleUpdateHotelUnit("account_code", value)
                        }
                        pText={hotelUnitErrors?.account_code}
                        disabled={!canEditUnit}
                      />
                    </div>
                  )}

                  <div className="col-lg-4 col-sm-6">
                    <InputElement
                      mb4="mb-4"
                      labelHtmlFor="market_price"
                      labelClassName={`form-label ${stylesRequestData["form-label"]}`}
                      labelText="القيمة السوقية"
                      inputType="text"
                      inputClassName={`${stylesRequestData["form-control"]} form-control`}
                      inputID="market_price"
                      name="market_price"
                      allowedPattern={
                        /^(?!0+(?:\.0{0,2})?$)\d{0,19}(?:\.\d{0,2})?$/
                      }
                      placeholder="ادخل القيمة السوقية.."
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      value={currentHotelUnit.market_price || ""}
                      onChange={(pc, c, key, value) =>
                        handleUpdateHotelUnit("market_price", value)
                      }
                      pText={hotelUnitErrors?.market_price}
                      disabled={!canEditUnit}
                    />
                  </div>
                  <div className="col-lg-4 col-sm-6">
                    <InputElement
                      mb4="mb-4"
                      labelHtmlFor="annual_rent"
                      labelClassName={`form-label ${stylesRequestData["form-label"]}`}
                      labelText="القيمة الإيجارية السنوية"
                      inputType="text"
                      inputClassName={`${stylesRequestData["form-control"]} form-control`}
                      inputID="annual_rent"
                      name="annual_rent"
                      allowedPattern={
                        /^(?!0+(?:\.0{0,2})?$)\d{0,19}(?:\.\d{0,2})?$/
                      }
                      placeholder="ادخل القيمة الإيجارية السنوية.."
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      value={currentHotelUnit.annual_rent || ""}
                      onChange={(pc, c, key, value) =>
                        handleUpdateHotelUnit("annual_rent", value)
                      }
                      pText={hotelUnitErrors?.annual_rent}
                      disabled={!canEditUnit}
                    />
                  </div>
                </>
              )}

              <div className="d-flex flex-lg-row flex-column gap-3 align-items-start mb-3">
                <div className="d-flex flex-column">
                  <button
                    type="button"
                    onClick={handleAddHotelUnit}
                    className={`${stylesRequestData["btn-request"]}`}
                  >
                    {editingHotelUnitIndex !== null ? "حفظ" : "إضافة وحدة"}
                  </button>
                  {addHotelUnitErrorMessage && (
                    <p className="text-danger mb-0 mt-2 me-2 fw-bolder">
                      {addHotelUnitErrorMessage}
                    </p>
                  )}
                </div>

                {editingHotelUnitIndex !== null && (
                  <div>
                    <button
                      type="button"
                      className={`${stylesRequestData["btn-cancel"]}`}
                      onClick={handleCancelHotelUnit}
                    >
                      إلغاء
                    </button>
                  </div>
                )}
              </div>
            </>
          )}
          {Array.isArray(getMatchingHotelUnits(declarationRequest)) &&
            getMatchingHotelUnits(declarationRequest)?.length > 0 && (
              <div className="row mb-3">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>رقم المبنى</th>
                          <th>رقم الدور</th>
                          <th>رقم الوحدة</th>
                          <th>نوع النشاط</th>
                          <th>المساحة</th>
                          <th>داخل رخصة التشغيل؟</th>
                          <th>كود حساب الوحدة</th>
                          <th>القيمة السوقية</th>
                          <th>القيمة الإيجارية السنوية</th>
                          {!declarationRequest?.viewMode &&
                            !declarationRequest?.isUnitViewMode && <th> </th>}
                        </tr>
                      </thead>
                      <tbody>
                        {getMatchingHotelUnits(declarationRequest)?.map(
                          (unit, index) => (
                            <tr key={index}>
                              <td data-label="رقم المبنى">
                                {resolveBuildingLabel(unit?.building_id)}
                              </td>
                              <td data-label="رقم الدور">
                                {resolveFloorLabel(unit.floor_number_id)}
                              </td>
                              <td data-label="رقم الوحدة">
                                {unit.unit_number}
                              </td>
                              <td data-label="نوع النشاط">
                                {unit.activity_type}
                              </td>
                              <td data-label="المساحة">{unit.area}</td>
                              <td data-label="داخل رخصة التشغيل؟">
                                {parseInt(unit.inside_operation_license) === 1
                                  ? "نعم"
                                  : "لا"}
                              </td>
                              <td data-label="كود حساب الوحدة">
                                {unit.account_code || "-"}
                              </td>
                              <td data-label="القيمة السوقية">
                                {unit.market_price || "-"}
                              </td>
                              <td data-label="القيمة الإيجارية السنوية	">
                                {unit.annual_rent || "-"}
                              </td>
                              <td data-label="إجراءات">
                                {canEditUnit && (
                                  <div
                                    className={`d-flex ${stylesRequestData["action-buttons-small-screen"]}`}
                                  >
                                    <div
                                      className={`${stylesRequestData["action-buttons"]}`}
                                    >
                                      {!declarationRequest?.viewMode && (
                                        <>
                                          <button
                                            type="button"
                                            className={`${stylesRequestData["btn-edit"]}`}
                                            onClick={() =>
                                              handleEditHotelUnit(
                                                unit,
                                                unit?.id,
                                              )
                                            }
                                            disabled={
                                              editingHotelUnitIndex !== null
                                            }
                                            title="تعديل الوحدة"
                                          >
                                            <i className="fa-solid fa-pen-to-square"></i>
                                          </button>

                                          <button
                                            type="button"
                                            className={`${stylesRequestData["btn-delete-icon"]}`}
                                            onClick={() =>
                                              openDeleteHotelUnitModal(
                                                unit,
                                                index,
                                              )
                                            }
                                            title="حذف الوحدة"
                                            disabled={
                                              editingHotelUnitIndex !== null
                                            }
                                          >
                                            <i className="fa-solid fa-trash-can"></i>
                                          </button>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </td>
                            </tr>
                          ),
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
        </>
      )}

      {!declarationRequest?.viewMode && !declarationRequest?.isUnitViewMode && (
        <>
          <div className="row mb-5 mt-5">
            <div className="col-md-4">
              <InputElement
                fileInputRef={constructionPermitsFileInputRef}
                mb4="mb-4"
                key={`hotel-${fileInputKeys.copy_of_the_construction_permits}`}
                inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                labelHtmlFor="copy_of_the_construction_permits"
                labelClassName={`${stylesRequestData["form-label"]} form-label`}
                labelText="صورة من التراخيص الإنشائية"
                inputType="file"
                inputClassName={`${stylesRequestData["form-control"]} form-control`}
                inputID="copy_of_the_construction_permits"
                name="copy_of_the_construction_permits"
                fileName={
                  declarationRequest?.unit?.copy_of_the_construction_permits
                    ?.original_file_name || "إرفاق ملف"
                }
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                icon="fa-solid fa-cloud-arrow-up"
                accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                pText={fileErrors["copy_of_the_construction_permits"]}
                hideErrorMessage
                onChange={handleChangeUnitFile}
                customServerInput={
                  declarationRequest?.unit?.copy_of_the_construction_permits !==
                    null &&
                  declarationRequest?.unit?.copy_of_the_construction_permits !==
                    undefined
                }
                disabled={!canEditUnit}
                deleteFunction={() => {
                  handleChangeDeclerationUnit(
                    "",
                    "",
                    "copy_of_the_construction_permits",
                    null,
                  );
                  if (constructionPermitsFileInputRef?.current) {
                    constructionPermitsFileInputRef.current.value = null;
                  }
                }}
              />
            </div>
            <div className="col-md-4">
              <InputElement
                fileInputRef={operatingLicensesFileInputRef}
                mb4="mb-4"
                key={`hotel-${fileInputKeys.copy_of_the_operating_licenses}`}
                inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                labelHtmlFor="copy_of_the_operating_licenses"
                labelClassName={`${stylesRequestData["form-label"]} form-label`}
                labelText="صورة من تراخيص التشغيل"
                inputType="file"
                inputClassName={`${stylesRequestData["form-control"]} form-control`}
                inputID="copy_of_the_operating_licenses"
                name="copy_of_the_operating_licenses"
                fileName={
                  declarationRequest?.unit?.copy_of_the_operating_licenses
                    ?.original_file_name || "إرفاق ملف"
                }
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                icon="fa-solid fa-cloud-arrow-up"
                accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                pText={fileErrors["copy_of_the_operating_licenses"]}
                hideErrorMessage
                onChange={handleChangeUnitFile}
                customServerInput={
                  declarationRequest?.unit?.copy_of_the_operating_licenses !==
                    null &&
                  declarationRequest?.unit?.copy_of_the_operating_licenses !==
                    undefined
                }
                disabled={!canEditUnit}
                deleteFunction={() => {
                  handleChangeDeclerationUnit(
                    "",
                    "",
                    "copy_of_the_operating_licenses",
                    null,
                  );
                  if (operatingLicensesFileInputRef?.current) {
                    operatingLicensesFileInputRef.current.value = null;
                  }
                }}
              />
            </div>
            <div className="col-md-4">
              <InputElement
                fileInputRef={stardomCertificateFileInputRef}
                mb4="mb-4"
                key={`hotel-${fileInputKeys.certificate_of_stardom_level}`}
                inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                labelHtmlFor="certificate_of_stardom_level"
                labelClassName={`${stylesRequestData["form-label"]} form-label`}
                labelText="شهادة بمستوى النجومية"
                inputType="file"
                inputClassName={`${stylesRequestData["form-control"]} form-control`}
                inputID="certificate_of_stardom_level"
                name="certificate_of_stardom_level"
                fileName={
                  declarationRequest?.unit?.certificate_of_stardom_level
                    ?.original_file_name || "إرفاق ملف"
                }
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                icon="fa-solid fa-cloud-arrow-up"
                accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                pText={fileErrors["certificate_of_stardom_level"]}
                hideErrorMessage
                onChange={handleChangeUnitFile}
                customServerInput={
                  declarationRequest?.unit?.certificate_of_stardom_level !==
                    null &&
                  declarationRequest?.unit?.certificate_of_stardom_level !==
                    undefined
                }
                disabled={!canEditUnit}
                deleteFunction={() => {
                  handleChangeDeclerationUnit(
                    "",
                    "",
                    "certificate_of_stardom_level",
                    null,
                  );
                  if (stardomCertificateFileInputRef?.current) {
                    stardomCertificateFileInputRef.current.value = null;
                  }
                }}
              />
            </div>
          </div>
        </>
      )}

      {(declarationRequest?.viewMode || declarationRequest?.isUnitViewMode) &&
        attachedEssentialDocuments.length > 0 && (
          <div className={`${stylesRequestData.box} box pdf-box`}>
            <h4 className={`${stylesRequestData["box-title"]} box-title mb-4`}>
              قائمة المستندات الأساسية
            </h4>
            <div className="row">
              {attachedEssentialDocuments.map((document) => (
                <div className="col-md-4" key={document.key}>
                  <label
                    htmlFor={document.key}
                    className={`${stylesRequestData["form-label"]} form-label`}
                  >
                    {document.label}
                  </label>
                  <div className="col-2-4 d-flex border border-2 rounded-3 shadow-sm fs-6 justify-content-between bg-light py-3 px-2 align-items-center mb-3">
                    <p
                      className="mb-0 file-name fs-6"
                      title={document.file?.original_file_name}
                    >
                      {document.file?.original_file_name}
                    </p>
                    <div className="d-flex align-items-center">
                      <span
                        type="button"
                        onClick={() =>
                          handlePreviewFile(document.file?.full_url)
                        }
                        className="text-danger border-0"
                      >
                        <i
                          className="fa-regular fa-eye fa-lg px-2"
                          style={{ color: "#32A8ED" }}
                        ></i>
                      </span>
                      <span
                        type="button"
                        onClick={() => DownloadFile(document.file?.full_url)}
                        className="text-danger border-0"
                      >
                        <i
                          className="fa-solid fa-cloud-arrow-down fa-lg px-2"
                          style={{ color: "#32A8ED" }}
                        ></i>
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
    </>
  );
};

export default HotelFacilitiesForm;
